document.addEventListener('DOMContentLoaded',() => {
    const accordionSelectors = ['.product__accordion','.faq__accordion']
    accordionSelectors.forEach((selector) => {
  		const accordions = document.querySelectorAll(selector)
        accordions.forEach((accordion) => {
          const summary = accordion.querySelector('summary')
          const details = accordion.querySelector('details')
          const content = accordion.querySelector('.accordion__content')
          summary.addEventListener('click',(e) => {
             e.preventDefault()
             if (details.open) {
              content.style.maxHeight = null
              content.addEventListener('transitionend', () => {
              	details.removeAttribute('open')
             },{once:true})
          	} else {
              details.setAttribute('open','')
	          content.style.maxHeight = content.scrollHeight + 'px' 
              accordions.forEach((child) => {
              const childSummary = child.querySelector('summary')
              const childDetails = child.querySelector('details')
              if (child !== accordion && childDetails.open) {
                childSummary.click()
              }
            })
            }                       
          })	
        })
	  });


	  const splide = new Splide( '.js-ingredient-slider', {
    type: 'loop',
    perPage: 1,
    focus: 'center',
    autoplay: true,
    interval: 3000,
    flickMaxPages: 1,
    updateOnMove: true,
    pagination: false,
    padding: '0%',
    throttle: 300,
    arrows: false,
    pagination: true,
    breakpoints: {
      821: {
        destroy: false, 
      },
      5000: {
        destroy: true 
      }
    }
  }).mount();
  
})